module.exports = __webpack_public_path__ + "static/media/web-logo-white.39524c52.svg";